// Adapted from React Bits SpotlightCard (MIT + Commons Clause):
// https://github.com/DavidHDev/react-bits/tree/main/src/content/Components/SpotlightCard
import { useRef } from 'react';
import './SpotlightCard.css';

export default function SpotlightCard({
  children,
  className = '',
  spotlightColor = 'rgba(255,255,255,.16)',
}) {
  const ref = useRef(null);
  const onMouseMove = (event) => {
    const element = ref.current;
    if (!element) return;
    const bounds = element.getBoundingClientRect();
    element.style.setProperty('--mouse-x', `${event.clientX - bounds.left}px`);
    element.style.setProperty('--mouse-y', `${event.clientY - bounds.top}px`);
  };
  return (
    <div
      ref={ref}
      className={`spotlight-card ${className}`}
      style={{ '--spotlight-color': spotlightColor }}
      onMouseMove={onMouseMove}
    >
      {children}
    </div>
  );
}
